import { RadioGroupRadioButton } from "@light-technology/components";
import { type Control, Controller, type Path } from "react-hook-form";
import { type Role } from "../../state/api.types";
import { ROLE_OPTIONS } from "../../utilities/role";

const ROLE_ITEMS = ROLE_OPTIONS.map((opt) => ({
  value: opt.value,
  title: opt.label,
  description: opt.description,
}));

export const RoleSelector = <T extends { role: Role }>(props: {
  control: Control<T>;
}) => {
  const name = "role" as Path<T>;
  return (
    <div>
      <div className="text-sm font-medium text-secondary">Permissions</div>
      <Controller
        control={props.control}
        name={name}
        rules={{ required: "This field is required" }}
        render={({ field: { ref: _ref, value, onChange, ...fieldRest } }) => (
          <RadioGroupRadioButton
            {...fieldRest}
            value={value}
            onChange={onChange}
            className="mt-2"
            aria-label="Permissions"
            items={
              ROLE_ITEMS as Parameters<typeof RadioGroupRadioButton>[0]["items"]
            }
          />
        )}
      />
    </div>
  );
};
